import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingStrokedButtonComponent } from './loading-stroked-button';
import { ButtonModule as MatButtonModule } from '@shared/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingSpinnerModule } from '@shared/components/loading-spinner';
import { LoadingFlatButtonComponent } from './loading-flat-button';
import { LoadingBaseButtonComponent } from './loading-base-button';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, LoadingSpinnerModule],
  declarations: [LoadingBaseButtonComponent, LoadingStrokedButtonComponent, LoadingFlatButtonComponent],
  exports: [LoadingStrokedButtonComponent, LoadingFlatButtonComponent],
})
export class LoadingButtonsModule {}
